import type Keycloak from 'keycloak-js'
import HttpService from '@/common/services/HttpService'
import type { KeepAliveDTOLegacy } from '@/common/types/http'

export const KEEP_ALIVE_URL = '/rest/users/keepAlive'

const KEYCLOAK_TOKEN = 'kc_token'
const KEYCLOAK_REFRESH_TOKEN = 'kc_refreshToken'

export function getCurrentKeycloakToken(): string | null {
  return sessionStorage.getItem(KEYCLOAK_TOKEN)
}

export function updateKeycloakSessionStorage(keycloak: Keycloak) {
  sessionStorage.setItem(KEYCLOAK_TOKEN, <string>keycloak.token)
  sessionStorage.setItem(KEYCLOAK_REFRESH_TOKEN, <string>keycloak.refreshToken)
}

export function clearKeycloakSessionStorage() {
  sessionStorage.removeItem(KEYCLOAK_TOKEN)
  sessionStorage.removeItem(KEYCLOAK_REFRESH_TOKEN)
}

export function getCurrentKeycloakRefreshToken(): string | null {
  return sessionStorage.getItem(KEYCLOAK_REFRESH_TOKEN)
}

export const getKeepAliveSession = () => {
  return HttpService.get<KeepAliveDTOLegacy>(KEEP_ALIVE_URL)
}
